import { useState } from "react";

import { Button } from "@/components/ui";
import type { FieldDef } from "@/types/content";

import type { FormValues } from "../types";
import { isPresent } from "../utils";
import { DynamicField } from "./DynamicField";

interface Props {
  cluster: FieldDef[];
  values: FormValues;
  setValues: (patch: FormValues) => void;
}

const seedActiveId = (cluster: FieldDef[], values: FormValues): string =>
  (cluster.find((field) => isPresent(values[field.id])) ?? cluster[0]).id;

export const OneOfField = ({ cluster, values, setValues }: Props) => {
  const [activeId, setActiveId] = useState(() => seedActiveId(cluster, values));
  const activeField = cluster.find((m) => m.id === activeId) ?? cluster[0];

  const selectBranch = (fieldId: string) => {
    setActiveId(fieldId);
    const patch: FormValues = {};
    for (const field of cluster) {
      if (field.id !== fieldId) patch[field.id] = undefined;
    }
    setValues(patch);
  };

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2">
        {cluster.map((m) => (
          <Button
            key={m.id}
            variant={activeId === m.id ? "default" : "outline"}
            onClick={() => selectBranch(m.id)}
          >
            {m.label}
          </Button>
        ))}
      </div>
      <DynamicField
        field={activeField}
        value={values[activeField.id]}
        onChange={(v) => setValues({ [activeField.id]: v })}
      />
    </div>
  );
};
